"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketVersioningOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketVersioningOutput.js.map